export default __webpack_public_path__ + "static/media/i_bus-low_gn_tagless.7002d8b2.svg";